import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ImplementationTimeline } from './ImplementationTimeline';

interface ImplementationTimelineModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ImplementationTimelineModal({ isOpen, onClose }: ImplementationTimelineModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-[95vw] sm:w-[90vw] max-w-4xl max-h-[90vh] overflow-y-auto bg-white text-black">
        <DialogHeader className="bg-white">
          <DialogTitle className="text-black text-xl font-bold">
            Implementation Timeline
          </DialogTitle>
        </DialogHeader>
        <div className="p-4 bg-white text-black">
          <ImplementationTimeline />
        </div>
      </DialogContent>
    </Dialog>
  );
}
